import SectionCard from '../../components/ui/SectionCard'

function valueOrDash(value, fallback = '—') {
  if (value === undefined || value === null || value === '') return fallback
  return String(value)
}

export default function ExchangeRateCellDetails({ cell }) {
  if (!cell) {
    return null
  }

  return (
    <SectionCard
      title="Rate cell details"
      subtitle={`${valueOrDash(cell.baseCurrency)} -> ${valueOrDash(cell.quoteCurrency)}`}
      className="mt-4"
    >
      <dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-2 lg:grid-cols-3">
        <div><dt className="text-muted-foreground">baseCurrency</dt><dd>{valueOrDash(cell.baseCurrency)}</dd></div>
        <div><dt className="text-muted-foreground">quoteCurrency</dt><dd>{valueOrDash(cell.quoteCurrency)}</dd></div>
        <div><dt className="text-muted-foreground">rateDecimal</dt><dd>{valueOrDash(cell.rateDecimal)}</dd></div>
        <div><dt className="text-muted-foreground">rateDate</dt><dd>{valueOrDash(cell.rateDate)}</dd></div>
        <div><dt className="text-muted-foreground">fetchedAt</dt><dd>{valueOrDash(cell.fetchedAt)}</dd></div>
        <div><dt className="text-muted-foreground">source</dt><dd>{valueOrDash(cell.source)}</dd></div>
        <div><dt className="text-muted-foreground">sourcePriority</dt><dd>{valueOrDash(cell.sourcePriority)}</dd></div>
        <div><dt className="text-muted-foreground">status</dt><dd>{valueOrDash(cell.status)}</dd></div>
        <div><dt className="text-muted-foreground">freshness</dt><dd>{valueOrDash(cell.freshness)}</dd></div>
        <div><dt className="text-muted-foreground">isDerived</dt><dd>{String(Boolean(cell.isDerived))}</dd></div>
        <div><dt className="text-muted-foreground">derivedVia</dt><dd>{valueOrDash(cell.derivedVia)}</dd></div>
        <div><dt className="text-muted-foreground">validFrom</dt><dd>{valueOrDash(cell.validFrom)}</dd></div>
        <div><dt className="text-muted-foreground">validTo</dt><dd>{valueOrDash(cell.validTo)}</dd></div>
      </dl>
    </SectionCard>
  )
}
